<template>
    <div>
        <section class="breadcrumb-section cart">
            <div class="container"></div>
        </section>

        <section class="cart_page pt-0">
            <div class="container">
                <div class="row">
                    <div class="col-md-4"></div>
                    <div class="col-md-4 tahnkyou_center">
                        <div>
                            <h1 v-show="activeted">Thank you!</h1>
                            <h1 v-show="deactiveted">Oop's!</h1>
                            <p v-show="activeted">
                                You have successfully verified your email
                                address
                            </p>
                            <p v-show="deactiveted">
                                Your have already verified your email address
                            </p>
                        </div>
                        <div
                            v-if="userAuthenticated"
                            class="cart_buttons d-flex flex-wrap mt_28 align-items-center"
                        >
                            <a
                                href="/"
                                class="btn btn_primary bg_primary_blue text_white py_18 px_28"
                                >Go to Home
                            </a>
                        </div>
                        <div
                            v-else
                            class="cart_buttons d-flex flex-wrap mt_28 align-items-center"
                        >
                            <!-- <a href="/" class="btn btn_primary bg_primary_blue text_white py_18 px_28">Login</a> -->
                            <a
                                href="#"
                                class="btn btn_primary bg_primary_blue text_white py_18 px_28"
                                data-toggle="modal"
                                data-target="#login"
                            >
                                Back to Login
                            </a>
                        </div>
                    </div>
                    <div class="col-md-4"></div>
                </div>
            </div>
            <div class="containt_loader" v-show="isLoader">
                <div class="preloader-body">
                    <svg width="40" height="40" viewBox="0 0 40 40">
                        <polygon class="rect" points="0 0 0 40 40 40 40 0" />
                    </svg>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import ApiService from "@/common/api.service";

export default {
    name: "EmailVerify",
    computed: {
        ...mapGetters(["isAuthenticatedClient", "currentUserClient"]),
        tag() {
            return this.$route.params.tag;
        }
    },
    data() {
        return {
            activeted: true,
            deactiveted: false,
            isLoader: false,
            userAuthenticated: false
        };
    },
    components: {},
    mounted() {
        let _this = this;
        _this.queryString = window.location.search;

        this.getEmailVerification(this.$route.params.reset_token);
        if (this.isAuthenticatedClient) {
            this.userAuthenticated = true;
        } else {
            localStorage.setItem("user_login_home", 1);
            this.userAuthenticated = false;
        }
    },
    methods: {
        getEmailVerification(reset_token) {
            var _this = this;
            _this.isLoader = true;
            new Promise(() => {
                ApiService.get("/email-verification/" + reset_token)
                    .then(({ data }) => {
                        if (data.activation) {
                            _this.activeted = false;
                            _this.deactiveted = true;
                        }
                        _this.isLoader = false;
                    })
                    .catch(({ response }) => {
                        console.log(response.status.errors);
                    });
            });
        }
    }
};
</script>
